export const ADDITIONAL_PHOTOS_COUNT = 3;
